export default __webpack_public_path__ + "static/Pomorskie_Kompetencje_Jutra_LOGO_1-01-a317eeeb29fba249ee22838ad0dfb289.jpg";